import { useState } from "react";
import { SectionLabel } from "./WhatMakesSpecial";

const faqs = [
  {
    q: "Is Rolex9 legit in Australia?",
    a: "Yes. Rolex9 is a legitimate online casino platform operating under PAGCOR and Gaming Curacao licences. It is one of Australia's most recognised online casino brands, endorsed by international pop star Troye Sivan as brand ambassador for 2025/27. The platform has an active Trustpilot presence and a large, verified Australian player base. Visit rolex9.net to register."
  },
  {
    q: "Is Rolex9 safe to play at?",
    a: "Rolex9 uses SSL encryption and ThreatMetrix fraud detection to protect all player data and transactions. Games are independently certified by BMM Testlabs and TST Verified. The platform is licensed by both PAGCOR and Gaming Curacao. Responsible gambling tools including deposit limits and self-exclusion are available, with links to eCOGRA, Gambling Therapy and Gambling Help Online."
  },
  {
    q: "What is the minimum deposit at Rolex9?",
    a: "The minimum deposit at Rolex9 is AUD 19.00. This low entry point makes the platform accessible to all player levels. Supported deposit methods include PayID, OSKO, Visa, Mastercard, Apple Pay, Google Pay, AmoPay and SpeedPay."
  },
  {
    q: "What is the minimum withdrawal at Rolex9?",
    a: "The minimum withdrawal at Rolex9 is AUD 29.00. PayID and OSKO withdrawals are processed near-instantly via Australia's New Payments Platform. Bank transfer and card withdrawals typically take around  30 minutes."
  },
  {
    q: "What bonuses does Rolex9 offer?",
    a: "Rolex9 offers a random bonus on every deposit, New Register Free Credit Up To AUD 299 (no deposit required), Welcome Bonus 100%, Daily First Deposit 30%, Live Welcome Bonus 50%, Sport Welcome Bonus 50%, 7% Weekly Cash Back rebate on total losses, a daily rebate up to 5% for all members, weekly commissions up to 5% for all members, AUD 3 for every 1 share, and an exclusive monthly deposit ranking with an AUD 5,999 prize pool. Every deposit also triggers a random bonus automatically."
  },
  {
    q: "Does Rolex9 have a mobile app?",
    a: "Yes. Rolex9 offers a dedicated mobile app for both iOS and Android devices, downloadable directly from the Rolex9 website. The full casino experience is also available via mobile browser — no download required. Every deposit made through the app triggers a random bonus."
  },
  {
    q: "What games are available on Rolex9?",
    a: "Rolex9 offers thousands of games including slots from JILI, BNG, VPower, MEGA888, Live22, RICH88, 918KAYA, IMPERIUM, Rich Gaming and WF Gaming; live casino from Evolution, Sexy Baccarat (AESG), Dream Gaming and Tencent Poker; fishing games, table games (Baccarat, Blackjack, Roulette, Dragon Tiger) and a full sportsbook covering A-League, NBL, horse racing, UFC and more."
  },
  {
    q: "Who is Rolex9's brand ambassador?",
    a: "Rolex9's brand ambassador is Troye Sivan, the internationally acclaimed Australian pop star. Troye Sivan represents Rolex9 for the 2025/27 period, making Rolex9 one of the most high-profile online casino brands in Australia."
  },
  {
    q: "How do I contact Rolex9 support?",
    a: "Rolex9 offers 24/7 live chat directly on the website at rolex9.net, plus support via Telegram (@rolex9au), WhatsApp and Facebook. The team is always available to assist with account, bonus, payment or game queries — fast and friendly responses guaranteed."
  },
  {
    q: "How do I download the Rolex9 app?",
    a: "The Rolex9 app can be downloaded directly from the official website rolex9.net. It is available for both iOS and Android devices without going through the App Store or Google Play. Simply visit the site on your mobile browser and follow the install instructions."
  },
];

function FAQItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="glass-card rounded-xl overflow-hidden transition-all duration-300"
      style={{ borderColor: open ? "rgba(201,168,76,0.2)" : "rgba(255,255,255,0.05)" }}
    >
      <button
        className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-white/[0.02] transition-colors"
        onClick={() => setOpen(!open)}
      >
        <span className="text-white/65 font-medium text-sm pr-4" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          {q}
        </span>
        <span
          className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300"
          style={{
            background: open ? "rgba(201,168,76,0.15)" : "rgba(255,255,255,0.05)",
            border: `1px solid ${open ? "rgba(201,168,76,0.3)" : "rgba(255,255,255,0.08)"}`,
            color: open ? "#c9a84c" : "rgba(255,255,255,0.3)",
          }}
        >
          <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-xs`}></i>
        </span>
      </button>
      <div className={`faq-body ${open ? "open" : ""}`}>
        <div className="px-6 pb-5">
          <div className="h-px mb-4" style={{ background: "linear-gradient(90deg, rgba(201,168,76,0.2), transparent)" }}></div>
          <p className="text-white/35 text-xs leading-relaxed">{a}</p>
        </div>
      </div>
    </div>
  );
}

export default function ConclusionFAQ() {
  return (
    <>
      <section id="conclusion" className="max-w-5xl mx-auto px-6 py-12">
        <SectionLabel>Conclusion</SectionLabel>
        <div
          className="relative rounded-2xl p-8 overflow-hidden"
          style={{
            background: "linear-gradient(135deg, rgba(201,168,76,0.04) 0%, rgba(107,33,168,0.06) 50%, rgba(26,58,143,0.04) 100%)",
            border: "1px solid rgba(201,168,76,0.12)",
          }}
        >
          <div className="absolute top-0 right-0 w-40 h-40 opacity-20 pointer-events-none"
            style={{ background: "radial-gradient(circle at top right, rgba(201,168,76,0.5), transparent 70%)" }}
          ></div>
          <div className="space-y-4 relative z-10">
            <p className="text-white/45 text-sm leading-relaxed">
              Rolex9 is Australia&apos;s most recognisable online casino platform — endorsed by international pop star Troye Sivan and trusted by a large, active Australian player base. The combination of a random bonus on every deposit, New Register Free Credit Up To AUD 299 (no deposit required), Welcome Bonus 100%, Daily First Deposit 30%, daily rebate up to 5% for all members, 7% weekly rebate on total losses, weekly commissions up to 5% for all members, AUD 3 per share referral bonus and a monthly AUD 5,999 prize pool makes it one of the most rewarding platforms in the market.
            </p>
            <p className="text-white/45 text-sm leading-relaxed">
              The game library is extensive, covering slots from JILI, MEGA888, VPOWER, RICH88, 918KAYA, IMPERIUM, PLAYSTAR and VP; live casino from Evolution, Sexy Baccarat (AESG), Dream Gaming and Tencent Poker; fishing games, table games and a full sportsbook. With a minimum deposit of just AUD 19.00, the platform is accessible to all player levels.
            </p>
            <p className="text-white/45 text-sm leading-relaxed">
              Australian players are particularly well served with PayID and OSKO — near-instant deposits and withdrawals via Australia&apos;s New Payments Platform. Apple Pay, Google Pay, Visa, Mastercard, AmoPay and SpeedPay are also fully supported. Minimum withdrawal is AUD 29.00.
            </p>
            <p className="text-white/45 text-sm leading-relaxed">
              With 24/7 live chat, Telegram (@rolex9au), WhatsApp and Facebook support, a dedicated mobile app, dual licensing by PAGCOR and Gaming Curacao, independent game certification by BMM Testlabs and TST Verified, and responsible gambling tools via eCOGRA and Gambling Help Online, Rolex9 delivers a complete, trustworthy and entertaining online casino experience built specifically for Australian players.
            </p>
          </div>
        </div>
      </section>

      <section id="faq" className="max-w-5xl mx-auto px-6 py-12">
        <SectionLabel>FAQ</SectionLabel>
        <div className="space-y-3">
          {faqs.map((f, i) => <FAQItem key={i} q={f.q} a={f.a} />)}
        </div>
      </section>
    </>
  );
}
